module.exports = __webpack_public_path__ + "static/Grocery-Retailers-623622a3ef2bc75331fe777c8641451a.jpg";